import { createContext } from 'react';

export const PageCardsContext = createContext({ width: 0 });
